import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebsocketStatusComponent } from './websocket-status.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    WebsocketStatusComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    WebsocketStatusComponent
  ]
})
export class WebsocketStatusModule { }
